import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SourcingEventV2Dto } from "../../../../../autogen/bff-api";
import { MilestoneTimeline } from "./MilestoneTimeline";

interface MilestonePlanCardProps {
  event: SourcingEventV2Dto;
}

const addMonths = (iso: string, months: number): string => {
  const d = new Date(iso);
  const day = d.getDate();
  d.setMonth(d.getMonth() + months);
  if (d.getDate() < day) d.setDate(0); // clamp end-of-month overflow (e.g. Jan 31 + 1 month)
  return d.toLocaleDateString("nb-NO");
};

export const MilestonePlanCard = ({ event }: MilestonePlanCardProps) => {
  const { t } = useTranslation();
  const { publicContext, eventData } = event;
  const validityMonths = publicContext.eFormsNoticeData?.tenderValidityMonths ?? null;
  const deadline = eventData.bidSubmissionDeadline ?? null;

  return (
    <Box borderWidth="1px" borderColor="smBorder" borderRadius="lg" bg="white" p="5" mb="8">
      <Flex align="flex-start" justify="space-between" mb="2" gap="6" wrap="wrap">
        <Heading as="h3" size="sm">{t("Process flow and milestone plan")}</Heading>
        {deadline && validityMonths != null && (
          <Box textAlign={{ base: "left", md: "right" }}>
            <Text fontSize="xs" color="smMuted">
              {t("Tender validity until ~{{date}} ({{months}} months from bid deadline)", {
                date: addMonths(deadline, validityMonths),
                months: validityMonths,
              })}
            </Text>
          </Box>
        )}
      </Flex>

      <Box py={{ base: 6, md: 6 }}>
        <MilestoneTimeline mode="edit" event={event} />
      </Box>
    </Box>
  );
};
